<div class="dash-card no-padding">
    <div class="dash-card-header d-block" style="flex-direction: column;">
        <div class="row no-gutters">
            <div class="col-12">
                <div style="padding-bottom: 0;">
                    <h2>Perfis de acesso</h2>
                    <p>Vincule perfis de acesso a esta empresa para definir
                        seus
                        acessos.</p>
                </div>
            </div>

            <div class="col-12 d-flex justify-content-between align-items-center mt-5 px-0"
                *ngIf="loading || data.length > 0 || hasFilters">
                <div class="d-flex align-items-center">
                    <button type="button" class="sort-button mr-2"
                        (click)="refreshData()" [disabled]="loading">
                        <svg-icon src="assets/images/icon-renew.svg"></svg-icon>
                        <span>Atualizar</span>
                    </button>
                </div>

                <div class="d-flex align-items-center">
                    <app-button
                        *ngIf="hasFilters && permissionObj.canFilter && !loading"
                        [danger]="true" [outline]="true" class="add-button mr-2"
                        (onClick)="resetForm()">
                        <svg-icon src="assets/images/icon-times.svg"
                            class="filter-clear-icon"></svg-icon>
                        Limpar filtros
                    </app-button>

                    <app-button [inverted]="true" class="add-button mr-2"
                        (onClick)="toggleFilterModal()" [disabled]="loading"
                        *ngIf="permissionObj.canFilter && (loading || data.length > 0 || hasFilters)">
                        <svg-icon src="assets/images/icon_filter.svg"
                            class="mr-2"></svg-icon>
                        {{ hasFilters ? 'Editar filtros' : 'Filtrar listagem' }}
                    </app-button>

                    <app-button (onClick)="bondUserProfile()" class="add-button"
                        *ngIf="permissionObj.canAdd && (loading || data.length > 0 || hasFilters)">
                        <svg-icon src="assets/images/icon-link.svg"
                            class="mr-2 mt-1 mb-1"></svg-icon>
                        Vincular perfis de acesso
                    </app-button>
                </div>
            </div>

            <div class="col-12 mt-3 px-0"
                *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-end">
                    <app-filter-tag *ngFor="let filter of appliedFilters"
                        [label]="filter.label" [value]="filter.value">
                    </app-filter-tag>
                </div>
            </div>
        </div>
    </div>

    <div class="dash-card-body padding-container"
        style="margin-top: 32px; overflow: visible;">
        <ng-container *ngIf="loading">
            <table #table class="bordered">
                <tbody>
                    <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                        <td>
                            <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '200px',
                                        marginBottom:'0'
                                          }">
                            </ngx-skeleton-loader>
                        </td>
                        <td>
                            <div
                                style="display: flex; flex-direction: column; gap: 8px;">
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '120px',
                                    marginBottom:'0'
                                  }">
                                </ngx-skeleton-loader>
                                <ngx-skeleton-loader [theme]="{
                                    height: '14px',
                                    width: '100px',
                                    marginBottom:'0'
                                  }">
                                </ngx-skeleton-loader>
                            </div>
                        </td>
                        <td>
                            <ngx-skeleton-loader [theme]="{
                                height: '24px',
                                width: '70px',
                                marginBottom:'0'
                              }">
                            </ngx-skeleton-loader>
                        </td>
                        <td>
                            <div
                                style="display: flex; gap: 16px; justify-content: flex-end;">
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '16px',
                                    marginBottom:'0',
                                    borderRadius: '0'
                                  }">
                                </ngx-skeleton-loader>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

        <table class="bordered" *ngIf="!loading && data.length > 0">
            <thead>
                <tr>
                    <th>Perfil de acesso</th>
                    <th>Atualizado em</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let item of data; trackBy: trackByItemId">
                    <td>
                        {{item.description}}
                    </td>

                    <td>
                        <div class="dash-card-item-content">
                            <div class="dash-card-item-content-title">
                                {{displayDateTime(item.updated_at).date}}
                            </div>
                            <div class="dash-card-item-content-subtitle">
                                {{displayDateTime(item.updated_at).time}}
                            </div>
                        </div>
                    </td>

                    <td>
                        <div class="status-tag"
                            [class.-inactive]="item.status === 'inactive'">
                            {{getStatusDisplay(item.status)}}</div>
                    </td>

                    <td>
                        <div class="table-options">
                            <app-tooltip text="Desvincular" [position]="'top'">
                                <button class="dash-item-button"
                                    (click)="openUnlinkModal(item)">
                                    <svg-icon
                                        src="assets/images/icon-unlink.svg"></svg-icon>
                                </button>
                            </app-tooltip>
                            <app-tooltip
                                [text]="item.status === 'active' ? 'Inativar' : 'Ativar'"
                                [position]="'top'"
                                *ngIf="permissionObj.canInactive">
                                <button class="dash-item-button"
                                    (click)="toggleStatus(item.id)">
                                    <svg-icon src="assets/images/icon-ban.svg"
                                        fill="var(--danger)"
                                        *ngIf="item.status === 'active'"></svg-icon>
                                    <svg-icon
                                        src="assets/images/icon-check-filled.svg"
                                        fill="var(--success)"
                                        *ngIf="item.status === 'inactive'"></svg-icon>
                                </button>
                            </app-tooltip>
                        </div>
                    </td>
                </tr>
            </tbody>
            <app-spacer [bottom]="28"></app-spacer>
        </table>

        <ng-container *ngIf="!loading && data.length === 0">
            <app-empty-content [isVisible]="true" [large]="true"
                [title]="hasFilters ? 'Nenhum resultado encontrado' : 'Não há nenhum perfil para exibir'"
                [description]="hasFilters ? 'Não encontramos nenhum perfil com os filtros aplicados. Tente ajustar os filtros ou limpar para ver todos os perfis.' : 'Não há perfis para serem exibidos no momento'"
                icon="/assets/images/figure_3d_search.png"
                [buttonLabel]="hasFilters ? undefined : 'Vincular perfis de usuários'"
                (onClick)="bondUserProfile()">
            </app-empty-content>
        </ng-container>
    </div>
</div>

<div class="col-12 ml-auto mr-auto" *ngIf="data.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="data" [count]="count || data.length"
            [show]="!loading" [offset]="offset"
            (onPageChange)="changePageData($event)" [dashPagination]="true">
        </app-pagination>
    </div>
</div>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="name"
                placeholder="Digite" label="Perfil de usuários">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="start_date"
                mask="00/00/0000" label="Data de início"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="end_date"
                mask="00/00/0000" label="Data final" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>

<!-- Carbon Warning Modal para desvincular -->
<app-carbon-warning-modal [active]="showUnlinkModal"
    title="Desvincular perfil de acesso" [message]="getUnlinkModalMessage()"
    confirmText="Sim, desvincular" [cancelText]="'Não, cancelar'"
    [confirmAction]="confirmUnlink.bind(this)"
    [cancelAction]="closeUnlinkModal.bind(this)" (onClose)="closeUnlinkModal()">
</app-carbon-warning-modal>

<!-- Carbon Warning Modal para aviso de departamentos afetados -->
<app-carbon-warning-modal [active]="showDepartmentsWarningModal"
    title="Atenção: Departamentos afetados"
    [message]="getDepartmentsWarningMessage()"
    confirmText="Sim, desvincular mesmo assim" [cancelText]="'Não, cancelar'"
    [confirmAction]="proceedWithUnlink.bind(this)"
    [cancelAction]="closeDepartmentsWarningModal.bind(this)"
    (onClose)="closeDepartmentsWarningModal()">
</app-carbon-warning-modal>

<app-loading-spinner [active]="showLoadingSpinner"></app-loading-spinner>